import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Toggle } from '../../../../components';
import { makePatch } from '../../../../api/ajax';

const MfaModal = ({ show, mfaEnabled, onModalClose, onUpdated }) => {
  const onToggleClick = () => {
    makePatch('users/me/mfa', { mfaEnabled: !mfaEnabled }).subscribe(
      ({ response }) => onUpdated(response)
    );
  };

  return (
    <Modal
      headerText="Multi-factor authentication"
      size="md"
      backdrop="static"
      onHide={() => onModalClose(false)}
      show={show}
    >
      <Modal.Body>
        <div className="d-flex justify-content-between align-items-center">
          <div>Require multi-factor authentication for my account</div>
          <div>
            <Toggle
              on={mfaEnabled}
              toggleClick={onToggleClick}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

MfaModal.propTypes = {
  show: PropTypes.bool,
  mfaEnabled: PropTypes.bool,
  onModalClose: PropTypes.func,
  onUpdated: PropTypes.func,
};

export default MfaModal;
